var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9567 9.23556C26.2469 4.57185 21.2889 2 16.0001 2C10.7112 2 5.7532 4.57185 2.04344 9.23556C1.6893 9.68 1.6893 10.314 2.04344 10.7585C5.7532 15.4282 10.7112 18 16.0001 18C21.2889 18 26.2469 15.4282 29.9567 10.7644C30.3108 10.32 30.3108 9.68 29.9567 9.23556ZM16.0001 13.9644C13.8578 13.9644 12.1161 12.1867 12.1161 10C12.1161 7.81333 13.8578 6.03556 16.0001 6.03556C18.1423 6.03556 19.884 7.81333 19.884 10C19.884 12.1867 18.1423 13.9644 16.0001 13.9644ZM4.51661 10C6.71112 7.49926 9.32944 5.78667 12.151 4.96889C10.688 6.13629 9.74164 7.95556 9.74164 10C9.74164 12.0385 10.6821 13.8578 12.151 15.0311C9.32944 14.2133 6.71693 12.5007 4.51661 10ZM19.8491 15.0311C21.3121 13.8637 22.2585 12.0444 22.2585 10C22.2585 7.96148 21.318 6.14222 19.8491 4.96889C22.6706 5.78667 25.2889 7.49926 27.4835 10C25.2832 12.5007 22.6706 14.2133 19.8491 15.0311Z",
    fill: "#BDCAD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.9951,
    width: 3,
    height: 20.5,
    rx: 1.5,
    transform: "rotate(22.3787 18.9951 0)",
    fill: "#BDCAD5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEye);
export default __webpack_public_path__ + "res/media/no-eye.b9ec5a9fe64d4e33f3164c0f73582eba.svg";
export { ForwardRef as ReactComponent };